import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalErrorHandler } from './global-error-handler';

@NgModule({
  imports: [CommonModule],
})
export class SharedErrorHandlingModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedErrorHandlingModule,
      providers: [{ provide: ErrorHandler, useClass: GlobalErrorHandler }],
    };
  }
}
